import { Component, OnInit, Input } from '@angular/core';
import { FilterService } from '../filter.service'
import { Tag } from '../tag'

@Component({
  selector: 'app-tag-filter',
  templateUrl: './tag-filter.component.html',
  styleUrls: ['./tag-filter.component.css']
})
export class TagFilterComponent implements OnInit {
  @Input() tag: Tag
  @Input() isManual = false

  constructor(
    private fs: FilterService
  ) { }

  ngOnInit() {

  }

  get label() {
    return this.tag.title
  }

  switch(event) {
    if (event.ctrlKey)
      this.fs.setExcludeTagFilter(this.tag)
    else
      this.fs.setTagFilter(this.tag)
  }

  get isSelected() {
    return this.fs.isSelectedTag(this.tag)
  }

  get isExcluded() {
    return this.fs.isExcludedTag(this.tag)
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/tag-filter/tag-filter.component.ts